import { render, staticRenderFns } from "./AppTabConfigForm.vue?vue&type=template&id=70cde1c3&"
import script from "./AppTabConfigForm.vue?vue&type=script&lang=js&"
export * from "./AppTabConfigForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports